// Cycle 11 followup-5 Commit E (2026-05-17) — read the storefront-i18n
// window-bridge JSON so on-page badge text / currency formatting honour
// motor.dil instead of the legacy TR / TL hardcodes. The bridge is
// emitted by `snippets/ecomnodes-storefront-i18n.liquid` and populated by
// Phase F section-builders. Missing / malformed bridge falls back to a
// neutral English default so the UI never shows TR copy on a non-TR
// storefront.
function __ecomnodesReadStorefrontI18n() {
  try {
    var node = document.getElementById('ecomnodes-storefront-i18n');
    if (!node) return {};
    var parsed = JSON.parse(node.textContent || '{}');
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch (e) {
    return {};
  }
}

// Cycle 23 L (Madde 13) — standard buy-button contract. Third-party buy-button
// apps (COD forms etc.) can only see a variant selection through the standard
// theme signals: a 'change' event on the cart form's hidden [name=id] input and
// the ?variant= URL param (many apps monkey-patch history.replaceState and
// re-read it on every write — the most robust channel). A bare `.value =` write
// is invisible to both. Mini copy of phero-variant-sync.js's syncFormSignals —
// the two assets load independently (single-variant products never load the
// sync asset), so no cross-file coupling.
function __pheroSyncFormSignals(variantId) {
  if (!variantId) return;
  var form = document.getElementById('product-form-hero');
  var idInput = form ? form.querySelector('[name="id"]') : null;
  if (idInput) {
    idInput.value = String(variantId);
    idInput.dispatchEvent(new Event('change', { bubbles: true }));
  }
  try {
    var params = new URLSearchParams(window.location.search);
    params.set('variant', String(variantId));
    window.history.replaceState(
      {},
      '',
      window.location.pathname + '?' + params.toString() + window.location.hash
    );
  } catch (e) {
    // URL sync is best-effort — never break the PDP over it.
  }
}

if (!customElements.get('bundle-selector')) {
  customElements.define('bundle-selector', class BundleSelector extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.section;
      this.dataEl = this.querySelector(`#bundle-data-${this.sectionId}`);
      if (!this.dataEl) return;

      this.config = JSON.parse(this.dataEl.textContent);
      this.i18n = __ecomnodesReadStorefrontI18n();
      // Cycle 23 B3 C6 — mix-bundle variant data. Present ONLY on multi-variant
      // products (phero-variant-map/phero-option-names are emitted `unless
      // has_only_default_variant`). When absent, `hasVariants` stays false and
      // every path below falls through to the legacy single-line × qty-N flow.
      this.variantMap = this.readJSON('phero-variant-map-' + this.sectionId);
      this.optionNames = this.readJSON('phero-option-names-' + this.sectionId);
      this.hasVariants =
        Array.isArray(this.variantMap) &&
        this.variantMap.length > 0 &&
        Array.isArray(this.optionNames) &&
        this.optionNames.length > 0;
      this.optionValues = this.hasVariants ? this.computeOptionValues() : [];
      this.mainPickerEl = document.querySelector('.phero__variant-picker');
      // Cycle 23 B3 — variant picker UX redesign. The per-unit selects now live
      // INSIDE each bundle card (`.bcard > [data-card-units]`), so there is no
      // longer a single standalone `[data-unit-pickers]` element. `this.cards`
      // is the ordered list of bundle cards; each carries its own holder that
      // renderUnitPickersInto() fills for the selected card only.
      this.cards = this.querySelectorAll('.bcard');
      this.bundleCount = Array.isArray(this.config.bundles) ? this.config.bundles.length : 0;
      // Requirement 1 + Madde 16 (Cycle 23 N): with bundles present, variant
      // selection happens inside the cards, so the standalone main picker above
      // is redundant → hide it (even on the qty-1 tier) — UNLESS the merchant
      // explicitly flipped the block's `visible` toggle in the theme editor
      // (the liquid wrapper carries it as data-merchant-visible). The opt-in
      // overrides the hide; main picker + card-embedded pickers then coexist
      // by design (the main picker publishes variantChange, our subscription
      // rebuilds the card pickers — no extra conflict logic). A missing attr
      // (legacy bake) keeps today's hide. A bundle-less hero (theme-editor
      // removed all bundle_option blocks) keeps the main picker visible as the
      // sole selector. Single-variant products have no map → no picker to hide.
      if (this.hasVariants && this.bundleCount > 0 && this.mainPickerEl && this.mainPickerEl.dataset.merchantVisible !== 'true') {
        this.mainPickerEl.setAttribute('hidden', 'hidden');
      }
      this.radios = this.querySelectorAll('input[name="bundle-select"]');
      this.priceEl = document.querySelector('.phero__price');
      this.compareEl = document.querySelector('.phero__compare');
      this.badgeEl = document.querySelector('.phero__discount-badge');
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitBtn = this.querySelector('.phero__cart-btn');
      this.formEl = this.querySelector('form#product-form-hero');

      // Disable product-form.js default handler
      const productFormCE = this.querySelector('product-form');
      if (productFormCE) {
        const oldBtn = this.submitBtn;
        if (oldBtn) {
          const newBtn = oldBtn.cloneNode(true);
          oldBtn.parentNode.replaceChild(newBtn, oldBtn);
          this.submitBtn = newBtn;
        }
      }

      if (this.formEl) {
        this.formEl.addEventListener('submit', (e) => {
          e.preventDefault();
          e.stopPropagation();
        }, true);
      }

      if (this.submitBtn) {
        this.submitBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.onSubmit();
        });
      }

      this.radios.forEach(r => r.addEventListener('change', this.onSelect.bind(this)));

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, (evt) => {
          if (evt.data?.variant?.id) {
            this.config.productVariantId = evt.data.variant.id;
            this.config.productPrice = evt.data.variant.price;
            // Cycle 23 L — route through the form-signal helper (change
            // dispatch + ?variant= URL) instead of a bare .value write, so
            // buy-button apps see the update too.
            __pheroSyncFormSignals(evt.data.variant.id);
            const checked = this.querySelector('input[name="bundle-select"]:checked');
            if (checked) this.onSelect({ target: checked });
          }
        });
      }

      const initial = this.querySelector('input[name="bundle-select"]:checked');
      if (initial) this.onSelect({ target: initial });
    }

    getBundle(index) {
      return this.config.bundles[index] || null;
    }

    onSelect(evt) {
      const idx = parseInt(evt.target.value, 10);
      const bundle = this.getBundle(idx);
      if (!bundle) return;

      this.querySelectorAll('.bcard').forEach((c, i) => {
        c.classList.toggle('bcard--selected', i === idx);
      });

      const mainTotal = this.config.productPrice * bundle.mainQuantity;
      let bundleDiscount = 0;
      if (bundle.discountType === 'percent' && bundle.discountValue > 0) {
        bundleDiscount = Math.round(mainTotal * bundle.discountValue / 100);
      } else if (bundle.discountType === 'fixed' && bundle.discountValue > 0) {
        bundleDiscount = bundle.discountValue * 100;
      }
      const finalPrice = Math.max(0, mainTotal - bundleDiscount);

      const retailCompare = (this.config.productComparePrice || 0) * bundle.mainQuantity;
      const compare = Math.max(retailCompare, mainTotal);
      const hasDiscount = compare > finalPrice;

      if (this.priceEl) this.priceEl.textContent = this.formatMoney(finalPrice);
      if (this.compareEl) {
        if (hasDiscount) {
          this.compareEl.textContent = this.formatMoney(compare);
          this.compareEl.style.display = '';
        } else {
          this.compareEl.style.display = 'none';
        }
      }
      if (this.badgeEl) {
        if (hasDiscount) {
          const discountPct = Math.round(((compare - finalPrice) / compare) * 100);
          // Cycle 11 followup-5 Commit E (2026-05-17): label + format come
          // from window-bridge i18n. Server-side Liquid populates
          // `config.badgeText` from `block.settings.badge_text` (Phase D
          // priceLabel) when present, with section.settings.discount_label_fallback
          // as the per-dil fallback. Bare 'OFF' is the universal neutral
          // backstop for a missing bridge.
          const label = this.config.badgeText || this.i18n.discountLabel || 'OFF';
          // Format template: '-{pct}% {label}' (EN/DE/FR/IT/ES/NL) or
          // '%{pct} {label}' (TR). Template uses (pct) + (label) placeholders
          // for parity with the Liquid renderer that consumes the same
          // string in `i18n.storefront.discountBadgeTemplate`.
          const fmt = this.i18n.bundleBadgeFormat || '-(pct)% (label)';
          this.badgeEl.textContent = fmt
            .replace('(pct)', String(discountPct))
            .replace('(label)', label);
          this.badgeEl.style.display = '';
        } else {
          this.badgeEl.style.display = 'none';
        }
      }

      // Cycle 23 B3 — render the per-unit variant pickers INSIDE this (the
      // selected) bundle card; empty + hide every other card's holder. Covers
      // the qty-1 tier too (one embedded picker), since the standalone main
      // picker is now hidden whenever bundles are present.
      this.updateCardVariants(idx);

      // Cycle 23 L (Madde 13) — standard buy-button contract: mirror the
      // tier's quantity to the form's hidden [name=quantity] (buy-button apps
      // scan for it; a programmatic write needs an explicit 'change' dispatch
      // to be seen) and re-sync the active main variant (the card was just
      // re-rendered). Our own AJAX submit never reads [name=quantity].
      if (this.formEl) {
        const qtyInput = this.formEl.querySelector('[name="quantity"]');
        if (qtyInput) {
          qtyInput.value = String(bundle.mainQuantity);
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      this.syncPrimaryVariant();
    }

    // Cycle 23 L — the "active main variant" a buy-button app should see is
    // the SELECTED card's unit-1 resolved variant (when the standalone picker
    // is visible instead, phero-variant-sync.js drives the same signals).
    // No-op on single-variant products (no map, no unit pickers).
    syncPrimaryVariant() {
      if (!this.hasVariants) return;
      const holder = this.selectedCardUnitsEl();
      if (!holder) return;
      const first = holder.querySelector('.phero__unit');
      if (!first) return;
      const v = this.unitVariant(first);
      if (v) __pheroSyncFormSignals(v.id);
    }

    // ─── Cycle 23 B3 C6 — mix-bundle per-unit variant pickers ────────────────

    readJSON(id) {
      const el = document.getElementById(id);
      if (!el) return null;
      try {
        return JSON.parse(el.textContent || 'null');
      } catch (e) {
        return null;
      }
    }

    // Distinct values per option index, in first-seen (cartesian) order.
    computeOptionValues() {
      const out = this.optionNames.map(() => []);
      this.variantMap.forEach((v) => {
        (v.options || []).forEach((val, i) => {
          if (out[i] && out[i].indexOf(val) === -1) out[i].push(val);
        });
      });
      return out;
    }

    matchVariant(values) {
      return (
        this.variantMap.find(
          (v) =>
            Array.isArray(v.options) &&
            v.options.length === values.length &&
            v.options.every((o, i) => o === values[i])
        ) || null
      );
    }

    // The current base variant (hidden id → map), used to seed unit defaults.
    baseVariant() {
      const input = this.formEl ? this.formEl.querySelector('[name="id"]') : null;
      const id = input ? Number(input.value) : this.config.productVariantId;
      return (
        this.variantMap.find((v) => v.id === id) ||
        this.variantMap.find((v) => v.available !== false) ||
        this.variantMap[0] ||
        null
      );
    }

    // The selected card's per-unit holder (`[data-card-units]`), or null.
    selectedCardUnitsEl() {
      const checked = this.querySelector('input[name="bundle-select"]:checked');
      if (!checked || typeof checked.closest !== 'function') return null;
      const card = checked.closest('.bcard');
      return card ? card.querySelector('[data-card-units]') : null;
    }

    // Cycle 23 B3 — render the per-unit variant pickers INTO the selected
    // bundle card; empty + hide every other card's holder so only the active
    // tier expands (compactness). No-op on single-variant products.
    updateCardVariants(selectedIdx) {
      if (!this.hasVariants || !this.cards) return;
      this.cards.forEach((card, i) => {
        const holder = card.querySelector('[data-card-units]');
        if (!holder) return;
        if (i === selectedIdx) {
          const bundle = this.getBundle(i);
          const qty = bundle ? bundle.mainQuantity : 1;
          this.renderUnitPickersInto(holder, qty);
          holder.removeAttribute('hidden');
        } else {
          holder.innerHTML = '';
          holder.setAttribute('hidden', 'hidden');
        }
      });
    }

    // Build `qty` unit pickers via the DOM API into `holder` (never innerHTML
    // with operator values — XSS-safe by construction). Each unit defaults to
    // the base variant. `.phero__unit-opt` is a <div> (NOT <label>) so it never
    // nests a second <label> inside the enclosing `.bcard` <label>; the option
    // name is mirrored onto the <select> via aria-label for accessibility.
    renderUnitPickersInto(holder, qty) {
      const base = this.baseVariant();
      const defaults =
        base && Array.isArray(base.options)
          ? base.options
          : this.optionValues.map((vals) => vals[0]);
      holder.innerHTML = '';
      for (let u = 0; u < qty; u++) {
        const unit = document.createElement('div');
        unit.className = 'phero__unit';
        unit.setAttribute('data-unit', String(u));

        // Per-unit numbering only helps when a tier holds more than one unit;
        // a single-unit tier stays compact without an "Ürün 1" label.
        if (qty > 1) {
          const label = document.createElement('div');
          label.className = 'phero__unit-label';
          label.textContent = 'Ürün ' + (u + 1);
          unit.appendChild(label);
        }

        for (let oi = 0; oi < this.optionNames.length; oi++) {
          const wrap = document.createElement('div');
          wrap.className = 'phero__unit-opt';
          const name = document.createElement('span');
          name.textContent = this.optionNames[oi];
          wrap.appendChild(name);

          const select = document.createElement('select');
          select.setAttribute('data-opt', String(oi));
          select.setAttribute('aria-label', this.optionNames[oi]);
          // Cycle 23 L — any per-unit change re-syncs the active main variant
          // (unit 1) to the form + URL so buy-button apps track the selection.
          select.addEventListener('change', () => this.syncPrimaryVariant());
          const vals = this.optionValues[oi] || [];
          for (let vi = 0; vi < vals.length; vi++) {
            const opt = document.createElement('option');
            opt.value = vals[vi];
            opt.textContent = vals[vi];
            if (vals[vi] === defaults[oi]) opt.selected = true;
            select.appendChild(opt);
          }
          wrap.appendChild(select);
          unit.appendChild(wrap);
        }
        holder.appendChild(unit);
      }
    }

    // Resolve a unit element's selected option values → variant (or null).
    unitVariant(unitEl) {
      const selects = unitEl.querySelectorAll('select[data-opt]');
      const values = Array.prototype.map.call(selects, (s) => s.value);
      return this.matchVariant(values);
    }

    // Cycle 23 L (Madde 13) — pure, side-effect-free snapshot of the shopper's
    // CURRENT selection, consumed by phero-cod-bridge.js (the deep COD-form
    // cart bridge) and unit tests. The bridge never re-derives DOM state; this
    // method is its single read surface. Returns null when there is nothing
    // meaningful to snapshot (no tier checked / unresolvable variant ids) so
    // the caller can fall back to the C1 standard form contract.
    getSelectionSnapshot() {
      const checked = this.querySelector('input[name="bundle-select"]:checked');
      if (!checked) return null;
      const tierIndex = parseInt(checked.value, 10);
      const bundle = this.getBundle(tierIndex);
      if (!bundle) return null;

      const primaryInput = this.formEl ? this.formEl.querySelector('[name="id"]') : null;
      const primaryVariantId = primaryInput
        ? Number(primaryInput.value)
        : Number(this.config.productVariantId);
      const mainQuantity = bundle.mainQuantity || 1;

      // Per-unit resolved variants from the selected card's embedded pickers;
      // single-variant products (or a picker gap) fall back to primary × qty.
      let units = [];
      if (this.hasVariants) {
        const holder = this.selectedCardUnitsEl();
        const unitEls = holder
          ? Array.prototype.slice.call(holder.querySelectorAll('.phero__unit'))
          : [];
        if (unitEls.length === mainQuantity && unitEls.length > 0) {
          for (const unitEl of unitEls) {
            const v = this.unitVariant(unitEl);
            if (!v) {
              units = [];
              break;
            }
            units.push({ variantId: v.id });
          }
        }
      }
      if (units.length === 0) {
        for (let i = 0; i < mainQuantity; i++) units.push({ variantId: primaryVariantId });
      }
      if (units.some((u) => !u.variantId || isNaN(u.variantId))) return null;

      const distinct = {};
      units.forEach((u) => {
        distinct[u.variantId] = true;
      });
      const gifts = (bundle.gifts || [])
        .filter((g) => g && g.variantId)
        .map((g) => ({ variantId: g.variantId, quantity: g.quantity || 1 }));

      return {
        tierIndex,
        mainQuantity,
        units,
        gifts,
        discountCode: bundle.discountCode || '',
        mixed: Object.keys(distinct).length > 1,
        primaryVariantId,
      };
    }

    showError(message) {
      let errorEl = this.querySelector('.phero__error');
      if (!errorEl) {
        errorEl = document.createElement('div');
        errorEl.className = 'phero__error';
        errorEl.setAttribute('role', 'alert');
        errorEl.setAttribute('aria-live', 'polite');
        const anchor = this.submitBtn && this.submitBtn.parentElement ? this.submitBtn : this;
        anchor.insertAdjacentElement('beforebegin', errorEl);
      }
      errorEl.textContent = message;
      errorEl.style.display = '';
      clearTimeout(this._errorTimer);
      this._errorTimer = setTimeout(() => { errorEl.style.display = 'none'; }, 4500);
    }

    setLoading(state) {
      if (!this.submitBtn) return;
      if (state) {
        this.submitBtn.setAttribute('disabled', 'disabled');
        this.submitBtn.classList.add('is-loading');
      } else {
        this.submitBtn.removeAttribute('disabled');
        this.submitBtn.classList.remove('is-loading');
      }
    }

    async onSubmit() {
      const checked = this.querySelector('input[name="bundle-select"]:checked');
      if (!checked) return;

      const bundle = this.getBundle(parseInt(checked.value, 10));
      if (!bundle) return;

      this.setLoading(true);

      const variantInput = this.formEl ? this.formEl.querySelector('[name="id"]') : null;
      const variantId = variantInput ? Number(variantInput.value) : this.config.productVariantId;

      if (!variantId || isNaN(variantId)) {
        this.showError('Lutfen bir beden/varyant secin.');
        this.setLoading(false);
        return;
      }

      try {
        // Step 1: Add main product with bundle info in properties
        const mainProps = {
          '_bundle_label': bundle.label
        };
        if (bundle.discountCode) {
          mainProps['_discount_code'] = bundle.discountCode;
        }

        // Cycle 23 B3 — mix-bundle: on a multi-variant product read each unit
        // from the SELECTED card's embedded picker and add it as its OWN line
        // (qty 1) with the shopper's per-unit variant. Same-variant units merge
        // server-side to a single line×qty; mixed variants stay separate —
        // either way the product-scoped min-qty auto discount evaluates on the
        // aggregate quantity (proven live in STEP 0). Otherwise (single-variant
        // product) the legacy single line×qty-N.
        const cardUnitsEl = this.hasVariants ? this.selectedCardUnitsEl() : null;
        const units = cardUnitsEl
          ? Array.prototype.slice.call(cardUnitsEl.querySelectorAll('.phero__unit'))
          : [];
        if (this.hasVariants && units.length === bundle.mainQuantity && units.length > 0) {
          const resolved = [];
          for (const unitEl of units) {
            const v = this.unitVariant(unitEl);
            if (!v) {
              this.showError('Lutfen tum urunler icin bir varyant secin.');
              this.setLoading(false);
              return;
            }
            if (v.available === false) {
              this.showError('Sectiginiz varyantlardan biri su an stokta yok.');
              this.setLoading(false);
              return;
            }
            resolved.push(v.id);
          }
          for (const variantId2 of resolved) {
            await this.addSingleItem(variantId2, 1, mainProps);
          }
        } else {
          await this.addSingleItem(variantId, bundle.mainQuantity, mainProps);
        }

        // Step 2: Add gift items
        for (const gift of (bundle.gifts || [])) {
          if (gift.variantId) {
            await this.addSingleItem(gift.variantId, gift.quantity || 1, {
              '_is_bundle_gift': 'true',
              '_gift_label': gift.label || ''
            });
          }
        }

        // Step 3: Apply discount code if set
        if (bundle.discountCode) {
          await this.applyDiscountCode(bundle.discountCode);
        }

        // Success
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bundle-selector' });
        }

        // If discount code exists, redirect through discount URL for guaranteed application
        if (bundle.discountCode) {
          window.location = '/discount/' + encodeURIComponent(bundle.discountCode) + '?redirect=/cart';
          return;
        }

        this.refreshCartUI();

      } catch (err) {
        console.error('Bundle add failed:', err);
        this.showError(err.message || 'Sepete eklenirken bir hata olustu. Lutfen tekrar deneyin.');
      } finally {
        this.setLoading(false);
      }
    }

    addSingleItem(id, quantity, properties) {
      const body = new FormData();
      body.append('id', id);
      body.append('quantity', quantity);
      if (properties && Object.keys(properties).length > 0) {
        for (const [key, val] of Object.entries(properties)) {
          body.append('properties[' + key + ']', val);
        }
      }

      return fetch('/cart/add.js', {
        method: 'POST',
        body: body
      })
      .then(r => r.json())
      .then(data => {
        if (data.status && data.status >= 400) {
          throw new Error(data.description || data.message || 'Urun eklenemedi');
        }
        return data;
      });
    }

    applyDiscountCode(code) {
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: code })
      })
      .then(r => {
        if (!r.ok) {
          console.error('Discount code apply failed:', code, 'HTTP', r.status);
        }
        return r.json();
      })
      .catch(err => {
        console.error('Discount code network error:', code, err);
      });
    }

    refreshCartUI() {
      if (this.cart && typeof this.cart.getSectionsToRender === 'function') {
        try {
          const sectionIds = this.cart.getSectionsToRender().map(s => s.id).join(',');
          fetch('/cart?sections=' + sectionIds)
            .then(r => r.json())
            .then(sections => {
              if (sections && typeof this.cart.renderContents === 'function') {
                this.cart.renderContents({ sections: sections });
              }
            })
            .catch(() => {
              window.location = '/cart';
            });
        } catch (e) {
          window.location = '/cart';
        }
      } else {
        window.location = '/cart';
      }
    }

    formatMoney(cents) {
      // Cycle 11 followup-5 Commit E (2026-05-17): currency-agnostic
      // formatter. Primary source for the currency code is
      // `window.Shopify.currency.active` (per-page, set by Shopify); the
      // window-bridge i18n only contributes the locale tag for digit grouping
      // and the fallback currency code when Shopify hasn't injected one yet.
      // Replaces the previous `toLocaleString('tr-TR', …) + ' TL'` hardcode.
      var shop = (typeof window !== 'undefined' && window.Shopify && window.Shopify.currency) || null;
      var currencyCode = (shop && shop.active) || this.i18n.currencyCode || 'USD';
      var locale = this.i18n.intlLocale || 'en-US';
      var amount = cents / 100;
      try {
        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency: currencyCode,
          maximumFractionDigits: 2,
        }).format(amount);
      } catch (e) {
        // Unknown ISO 4217 code or locale — fall back to a bare two-decimal
        // amount + ISO suffix so the storefront still renders a price.
        return amount.toFixed(2) + ' ' + currencyCode;
      }
    }
  });
}
